import { Calendar, Mail, Link as LinkIcon } from 'lucide-react';

const Contact = () => {
  return (
    <div className="pt-16">
      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-br from-primary to-primary/90">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-light text-text mb-6">
            Book a <span className="text-secondary">Free Consultation</span>
          </h1>
          <p className="text-xl text-muted max-w-3xl mx-auto leading-relaxed">
            Ready to transform your business with AI? Schedule a consultation to discuss how we can help you achieve your goals.
          </p>
        </div>
      </section>

      {/* Cal.com Embed Section */}
      <section className="py-20 bg-primary">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
            {/* Cal.com Embed */}
            <div className="lg:col-span-2">
              <div className="bg-gray-800 rounded-lg p-8">
                <h2 className="text-3xl font-light text-text mb-6">
                  Schedule Your Free Consultation
                </h2>
                <iframe
                  src="https://cal.com/luv-suneja?embed=true&theme=dark"
                  width="100%"
                  height="600"
                  frameBorder="0"
                  title="Book a consultation with Luv Suneja"
                  className="rounded-lg"
                ></iframe>
              </div>
            </div>

            {/* Contact Information */}
            <div>
              <h2 className="text-2xl font-light text-text mb-8">
                Other Ways to Connect
              </h2>
              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <Calendar className="h-6 w-6 text-secondary mt-1" />
                  <div>
                    <h3 className="font-medium text-text mb-2">Book a Meeting</h3>
                    <p className="text-muted text-sm">Schedule a consultation using the calendar on the left</p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <Mail className="h-6 w-6 text-secondary mt-1" />
                  <div>
                    <h3 className="font-medium text-text mb-2">Email</h3>
                    <a href="mailto:luv@recalibr.ai" className="text-secondary hover:text-cyan-400 text-sm">
                      luv@recalibr.ai
                    </a>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <LinkIcon className="h-6 w-6 text-secondary mt-1" />
                  <div>
                    <h3 className="font-medium text-text mb-2">LinkedIn</h3>
                    <a
                      href="https://ae.linkedin.com/in/luvsuneja"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-secondary hover:text-cyan-400 text-sm"
                    >
                      Connect on LinkedIn
                    </a>
                  </div>
                </div>
              </div>

              <div className="mt-12 p-6 bg-gray-800 rounded-lg">
                <h3 className="text-xl font-medium text-text mb-4">
                  What to Expect
                </h3>
                <ul className="space-y-3 text-muted text-sm">
                  <li className="flex items-start">
                    <span className="text-secondary mr-2">•</span>
                    <span>30-minute consultation to discuss your AI needs</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-secondary mr-2">•</span>
                    <span>Expert guidance on implementation strategies</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-secondary mr-2">•</span>
                    <span>Customized solutions for your business</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-secondary mr-2">•</span>
                    <span>No commitment required</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
